import { cva } from "@styled-system/css";

export const badgeClass = cva({
	base: {
		textAlign: "center",
		color: "shade.0",
		fontWeight: "bold",
		paddingY: "4",
	},
	variants: {
		environment: {
			production: {
				backgroundColor: "error.100",
			},
			staging: {
				backgroundColor: "warning.100",
			},
			development: {
				backgroundColor: "success.100",
			},
			warning: {
				backgroundColor: "error.100",
				color: "shade.0",
			},
		},
	},
});
